import { FC } from "react";
import {
  Box,
  CardActions,
  createStyles,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { ArrowForwardIos as ArrowForwardIcon } from "@material-ui/icons";
import { Alert, AlertTitle } from "@material-ui/lab";

import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    alertActionArea: {
      padding: 0,
      width: "100%",
      "& .MuiAlert-root": {
        width: "100%",
      },
      "& .MuiAlert-message": {
        flexGrow: 1,
      },
      "& .action": {
        color: theme.custom.palette.purple.main,
        opacity: 0.5,
      },
      "&:hover": {
        "& .action": {
          opacity: 1,
        },
        "& .nextArrow": {
          transform: "translateX(4px)",
        },
      },
      "& .nextArrow": {
        fontSize: "0.75rem",
        transition: "transform 200ms",
      },
    },
  }),
);

const AlertActionArea: FC<{
  alertTitle: string;
  alertDetails: string;
  actionMessage?: string;
}> = ({ alertTitle, alertDetails, actionMessage }) => {
  const classes = useStyles();
  return (
    <CardActions className={classes.alertActionArea}>
      <Alert severity="warning">
        <AlertTitle>{alertTitle}</AlertTitle>
        <Typography variant="body2">{alertDetails}</Typography>
        {!!actionMessage && (
          <Box
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="end"
            className="action"
          >
            {actionMessage}
            <ArrowForwardIcon className="nextArrow" />
          </Box>
        )}
      </Alert>
    </CardActions>
  );
};

export default AlertActionArea;
